import React, { useId } from 'react';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';
import styled from 'styled-components';

import Fieldset from '@rover/components/src/formFields/Fieldset';
import SingleSelectButtonGroup, {
  Props as SingleSelectButtonGroupProps,
  StyledSelectButton,
} from '@rover/components/src/formFields/SingleSelectButtonGroup';
import Calendar from '@rover/icons/svg/calendar.svg';
import Recurring from '@rover/icons/svg/recurring.svg';
import FilterLabel from '@rover/shared/js/search/components/FilterLabel';
import { ServiceFrequencyEnum } from '@rover/types/src/ServiceFrequency';

export const StyledButtonGroup = styled(
  SingleSelectButtonGroup as React.ComponentType<SingleSelectButtonGroupProps<ServiceFrequencyEnum>>
)`
  hyphens: auto;
  margin-bottom: ${({ theme }) => theme.space['3x']};
  overflow-wrap: break-word;
  word-wrap: break-word;

  ${StyledSelectButton} {
    background-color: ${({ theme }) => theme.background.primary};
    padding: ${({ theme }) => theme.space['3x']};
    word-break: break-word;
  }
`;

type Props = {
  displayAs?: 'compact' | 'expanded' | null;
  frequency?: ServiceFrequencyEnum;
  label: string;
  onChange: (serviceFrequency?: ServiceFrequencyEnum) => void;
  repeatIcon?: React.ComponentType;
};

const OneTimeRepeatToggleButtons = ({
  displayAs,
  frequency,
  label,
  onChange,
  repeatIcon,
  ...other
}: Props): JSX.Element => {
  const frequencyFilterId = useId();

  return (
    <Fieldset aria-labelledby={frequencyFilterId} {...other}>
      <FilterLabel id={frequencyFilterId}>
        <Trans id={label} />
      </FilterLabel>
      <StyledButtonGroup
        buttons={[
          {
            title: t`One Time`,
            value: ServiceFrequencyEnum.ONE_TIME,
            icon: Calendar,
            displayAs,
          },
          {
            title: t`Repeat Weekly`,
            value: ServiceFrequencyEnum.REPEAT,
            icon: repeatIcon || Recurring,
            displayAs,
          },
        ]}
        value={frequency}
        onChange={(v?: ServiceFrequencyEnum) => onChange(v)}
      />
    </Fieldset>
  );
};

export default OneTimeRepeatToggleButtons;
